import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { change } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

// component
import CommonImageDisplay from '../../../CommonImageDisplay/CommomImageDisplay';
import ImageUploadComponent from '../../../ImageUploadComponent/ImageUploadComponent';

// helpers
import { setLoaderStart, setLoaderComplete } from '../../../../../actions/loader/loader';
import { photosShow } from '../../../../../helpers/photosShow';
import { homebanneruploadDir } from '../../../../../config';
import { demoRestriction } from '../../../../../helpers/DemoRestriction/demoRestriction';

// style
import cs from '../../../../../components/commonStyle.css';
import s from './Image.css';
import messages from '../../../../../locale/jsonMessages';

class Image extends React.Component {

  static defaultProps = {
    loader: false
  };

  success = async (file, fromServer) => {
    const { change, setLoaderStart, setLoaderComplete, fieldName, demoRestriction } = this.props;
    let fileName = fromServer.file.filename;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await setLoaderStart(fieldName);
    await change('WhyHostForm', fieldName, fileName);
    await setLoaderComplete(fieldName);
  }

  render() {
    const { loader, image, fieldName } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(homebanneruploadDir);

    return (
      <div>
        <CommonImageDisplay
          loader={loader}
          image={image && path + image}
          isDefaultPic={image ? false : true}
          isDelete={false}
        />
        <ImageUploadComponent
          defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
          componentConfig={{
            iconFiletypes: ['.jpg', '.png', '.jpeg'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: '/uploadHomeBanner'
          }}
          loaderName={fieldName}
          success={this.success}
          className={cs.spaceTop3}
        />
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  setLoaderStart,
  setLoaderComplete,
  change,
  demoRestriction
};

export default compose(
  withStyles(cs, s),
  injectIntl,
  connect(mapState, mapDispatch)
)(Image);